export default __webpack_public_path__ + "static/media/sensor.5013fdee.jpg";